import React, { useState } from "react";
import toast from "react-hot-toast";
import HttpClientXml from "../utils/HttpClientXml";
import HomeService from "../Services/HomeService";
import { useNavigate } from "react-router-dom";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "rgb(131, 144, 155)",
  margin: "0px 0px 10px 0px",
  fontWeight: "bold",
};

function AddPeopleSaying() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    heading: "",
    name: "",
    designation: "",
    image: "",
  });
  const [imageLoading, setImageLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate image file
    if (!file.type.startsWith("image/")) {
      toast.error("Please select a valid image file");
      return;
    }

    setImageLoading(true);

    const data = new FormData();
    data.append("image", file);

    try {
      const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
      if (res?.image) {
        setFormData((prev) => ({ ...prev, image: res.image }));
        toast.success("Image uploaded successfully!");
      } else {
        toast.error(res?.message || "Failed to upload image");
      }
    } catch (error) {
      toast.error("Failed to upload image.");
      console.error("Error uploading image:", error);
    } finally {
      setImageLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.heading.trim()) {
      toast.error("Please enter a heading");
      return;
    }

    if (!formData.name.trim()) {
      toast.error("Please enter a name");
      return;
    }

    if (!formData.designation.trim()) {
      toast.error("Please enter a designation");
      return;
    }

    if (!formData.image) {
      toast.error("Please upload an image");
      return;
    }

    setLoading(true);

    // Prepare data according to Postman body structure
    const peopleSayingData = {
      heading: formData.heading.trim(),
      name: formData.name.trim(),
      designation: formData.designation.trim(),
      image: formData.image,
    };

    console.log("People Saying Data:", peopleSayingData);

    try {
      const res = await HomeService.createPeopleSaying(peopleSayingData);
      if (res?.status) {
        toast.success("Testimonial added successfully!");
        clearForm();
        navigate("/manage-people-saying");
      } else {
        toast.error(res?.message || "Failed to add testimonial.");
      }
    } catch (error) {
      toast.error("Failed to add testimonial.");
      console.error("Error adding testimonial:", error);
    } finally {
      setLoading(false);
    }
  };

  const clearForm = () => {
    setFormData({
      heading: "",
      name: "",
      designation: "",
      image: "",
    });
  };

  const removeImage = () => {
    setFormData((prev) => ({ ...prev, image: "" }));
    toast.success("Image removed");
  };

  return (
    <div className="main_wrap" style={{ marginTop: "6rem" }}>
      <div className="container-fluid">
        <div className="mt-5">
          <div style={headLineStyle} className="page-headline">
            Add People Saying
          </div>
          <hr />

          <section className="chartBox_area">
            <form onSubmit={handleSubmit}>
              <div className="row">
                {/* Image Upload Section */}
                <div className="col-md-6 mt-3">
                  <label htmlFor="image">
                    Upload Image<span className="text-danger">*</span>
                  </label>
                  <input
                    type="file"
                    id="image"
                    className="form-control"
                    onChange={handleImageUpload}
                    accept="image/*"
                    disabled={imageLoading}
                    required
                  />
                  <div className="form-text">
                    {imageLoading ? (
                      <span className="text-primary">
                        <i className="fa-solid fa-spinner fa-spin me-1"></i>
                        Uploading image...
                      </span>
                    ) : (
                      "Upload a portrait image of the person"
                    )}
                  </div>

                  {formData.image && (
                    <div className="mt-3 position-relative">
                      <div className="alert alert-success p-2">
                        <strong>Image Preview:</strong>
                      </div>
                      <img
                        src={formData.image}
                        alt="Person Preview"
                        style={{
                          maxHeight: "200px",
                          maxWidth: "100%",
                          borderRadius: "8px",
                          border: "2px solid #dee2e6",
                          objectFit: "cover",
                        }}
                      />
                      <button
                        type="button"
                        onClick={removeImage}
                        className="btn btn-danger btn-sm position-absolute"
                        style={{ top: "35px", right: "10px" }}
                      >
                        <i className="fa-solid fa-times"></i>
                      </button>
                    </div>
                  )}
                </div>

                {/* Heading Textarea */}
                <div className="col-md-6 mt-3">
                  <label htmlFor="heading">
                    Heading/Testimonial<span className="text-danger">*</span>
                  </label>
                  <textarea
                    id="heading"
                    className="form-control"
                    name="heading"
                    value={formData.heading}
                    onChange={handleChange}
                    rows="4"
                    placeholder="Enter testimonial or quote..."
                    required
                    style={{ height: "172px" }}
                  ></textarea>
                  <div className="form-text">
                    Enter what the person said (testimonial/quote)
                  </div>
                </div>

                {/* Name Input */}
                <div className="col-md-6 mt-3">
                  <label htmlFor="name">
                    Name<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    className="form-control"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter person's name..."
                    required
                  />
                  <div className="form-text">Enter the name of the person</div>
                </div>

                {/* Designation Input */}
                <div className="col-md-6 mt-3">
                  <label htmlFor="designation">
                    Designation<span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    id="designation"
                    className="form-control"
                    name="designation"
                    value={formData.designation}
                    onChange={handleChange}
                    placeholder="Enter designation (e.g., Software Engineer)..."
                    required
                  />
                  <div className="form-text">
                    Enter the designation or profession of the person
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <div className="row mt-4">
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn mt-3"
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                      padding: "10px 30px",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                    disabled={loading || imageLoading}
                  >
                    {loading ? (
                      <>
                        <i className="fa-solid fa-spinner fa-spin me-2"></i>
                        Adding Testimonial...
                      </>
                    ) : (
                      "Add Testimonial"
                    )}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary mt-3 ml-2"
                    style={{
                      borderRadius: "13px",
                      padding: "10px 30px",
                      fontSize: "16px",
                      fontWeight: "500",
                    }}
                    onClick={clearForm}
                  >
                    Clear Form
                  </button>
                </div>
              </div>
            </form>
          </section>
        </div>
      </div>
    </div>
  );
}

export default AddPeopleSaying;
